import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import Logo from "./Logo";

export default function LoginPage() {
    const handleGoogleLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A1A2F] via-[#11294A] to-[#0A1A2F] p-6" data-testid="login-page">
            <div className="max-w-md w-full bg-white rounded-3xl p-8 md:p-10 shadow-2xl">
                <Link to="/" className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-[#0A1A2F] mb-6" data-testid="back-home">
                    <ArrowLeft className="w-4 h-4" /> Kembali ke beranda
                </Link>
                <div className="mb-6">
                    <Logo size={42} />
                </div>
                <h1 className="font-display text-3xl font-bold text-[#0A1A2F]">Selamat datang, Kak!</h1>
                <p className="mt-3 text-sm text-slate-600">
                    Masuk ke Portal Klien untuk memantau progres aplikasi kuliahmu secara real-time.
                </p>

                <button
                    onClick={handleGoogleLogin}
                    data-testid="google-login-btn"
                    className="mt-8 w-full flex items-center justify-center gap-3 border-2 border-slate-200 hover:border-[#0A1A2F] hover:bg-[#0A1A2F] hover:text-white rounded-full py-3.5 font-semibold transition-all group"
                >
                    <svg className="w-5 h-5" viewBox="0 0 24 24">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                    </svg>
                    <span>Lanjut dengan Google</span>
                </button>

                <div className="mt-8 flex items-start gap-2 text-xs text-slate-500 bg-slate-50 rounded-2xl p-4">
                    <ShieldCheck className="w-4 h-4 text-[#F5A623] flex-shrink-0 mt-0.5" />
                    <p>Login aman dengan Google. Data Kakak terlindungi sesuai standar privasi internasional.</p>
                </div>
            </div>
        </div>
    );
}
